import { useSnackbar } from "@/alerts/index";
import { useAppConfigContext } from "@/context/AppConfig";
import { useAccountLists } from "@/dashboard/index";
import type { LizanoMetaData } from "@/reports/sections/ListsSection/lists/lists";

export function useSaveAction({
  reportPermaLink,
}: {
  reportPermaLink: string;
}) {
  const {
    data: list,
    createList,
    addReportToList,
    removeReportFromList,
  } = useAccountLists();
  const { trackEvent } = useAppConfigContext();
  const { enqueueSnackbar } = useSnackbar();
  const isSavedReportsList =
    list && list.length > 0 && list[0]?.name === "saved reports";

  let foundReportInSavedReports: LizanoMetaData | undefined;
  if (list && list.length > 0 && list[0]?.name === "saved reports") {
    foundReportInSavedReports = list[0]?.list_reports?.find(
      (report) => report?.report?.permalink === reportPermaLink,
    );
  }

  const handleCreateAddReportToList = () => {
    trackEvent("save report", "engagement click", "rats component");
    createList.mutate(
      {
        name: "saved reports",
        permalink: reportPermaLink,
      },
      {
        onSuccess: () =>
          enqueueSnackbar("Report was Saved", {
            variant: "success",
          }),
      },
    );
  };

  const handleRemoveFromList = () => {
    if (!list || !list[0] || !foundReportInSavedReports) return;

    removeReportFromList.mutate(
      {
        list_code: list[0].list_code,
        listReportId: foundReportInSavedReports.id,
      },
      {
        onSuccess: () =>
          enqueueSnackbar("Report was Unsaved", {
            variant: "success",
          }),
      },
    );
  };

  const handleAddReportToList = () => {
    if (!list || !list[0]) return;

    trackEvent("save report", "engagement click", "rats component");
    addReportToList.mutate(
      {
        list_code: list[0].list_code,
        reportPermaLink,
      },
      {
        onSuccess: () =>
          enqueueSnackbar("Report was Saved", {
            variant: "success",
          }),
      },
    );
  };

  const handleAddRemoveAction = () => {
    if (!isSavedReportsList) {
      handleCreateAddReportToList();
      return;
    }
    if (foundReportInSavedReports) {
      handleRemoveFromList();
      return;
    }
    if (!list || !list[0]) return;
    if (isSavedReportsList) {
      handleAddReportToList();
    }
  };

  return {
    isLoading: createList.isLoading || addReportToList.isLoading,
    foundReportInSavedReports,
    handleAddRemoveAction,
  };
}
